import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['GFS2 configuration and deployment', 'Distributed storage architecture', 'Cluster file system setup', 'Performance optimization', 'Backup and replication strategies', 'Migration from traditional storage'];
export function Capabilities() {
  return <section className="py-16" data-id="element-491">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-492">
        <div className="scroll-fade-in-up" data-id="element-493">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-494">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-495">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-496">
              We design and implement scalable, distributed file systems that
              provide synchronized, high-availability storage across multiple
              servers and geographic locations. Our expertise ensures seamless
              data access, robust disaster recovery, and optimized performance
              for enterprise-level storage requirements.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-497">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-498">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-499" />
                  <span className="text-gray-700" data-id="element-500">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}